import React from 'react';
import { DateEntry } from 'shared/lib/recharts';
import { Goal } from 'shared/types/goal';
import { LifeArea } from 'shared/types/life-area';
import { NumberFormat } from 'shared/types/number-format-options';
import { Timestamp } from 'shared/types/timestamp';
import { WeekDays } from 'shared/types/week-days';
import { getGoalDetailUrl } from 'shared/utils/get-goal-detail-url';

import * as Styled from './goal-insights-card.style';
import { Header } from './header';
import { InsightsCardContent } from './insights-card-content';

export type GoalInsightsCardProps = {
  goal: Goal;
  entries: DateEntry[];
  completionPercentage?: number;
  unitFormat?: string;
  startValue?: number;
  currentValue?: number;
  target?: number;
  timeframeDifference?: number;
  goals: Goal[];
  lifeAreas: LifeArea[];
  startDate: Timestamp;
  endDate: Timestamp;
  onPremium: () => void;
  menuButtonRef?: React.RefObject<HTMLButtonElement>;
  onMenuButton?: (e: React.MouseEvent) => void;
  onContextMenu?: (e: React.MouseEvent) => void;
  onEditGoalProgress?: (e: React.MouseEvent) => void;
  weekStartsOn: WeekDays;
  hasBigTitle?: boolean;
  hideHeader?: boolean;
  isEmpty?: boolean;
  isLink?: boolean;
  isLoading?: boolean;
  numberFormat?: NumberFormat;
  showLeftAxis?: boolean;
};

export const GoalInsightsCard: React.FC<GoalInsightsCardProps> = ({
  goal,
  entries,
  completionPercentage,
  unitFormat,
  startValue,
  currentValue,
  target,
  timeframeDifference,
  goals,
  lifeAreas,
  startDate,
  endDate,
  onPremium,
  menuButtonRef,
  onMenuButton,
  onContextMenu,
  weekStartsOn,
  onEditGoalProgress,
  hasBigTitle,
  hideHeader,
  isEmpty,
  isLink,
  isLoading,
  numberFormat,
  showLeftAxis,
}) => {
  const linksToDetail = !(isLoading || !isLink || goal.frozenAt);

  return (
    <Styled.Container
      as={linksToDetail ? undefined : 'span'}
      to={linksToDetail ? getGoalDetailUrl(goal) : ''}
      onClick={goal.frozenAt ? onPremium : undefined}
      onContextMenu={goal.frozenAt ? undefined : onContextMenu}
    >
      {!hideHeader && (
        <Header
          goal={goal}
          goals={goals}
          lifeAreas={lifeAreas}
          onMenuButton={onMenuButton}
          menuButtonRef={menuButtonRef}
          onEditGoalProgress={onEditGoalProgress}
          hasBigTitle={hasBigTitle}
        />
      )}

      <InsightsCardContent
        goal={goal}
        entries={entries}
        completionPercentage={completionPercentage}
        unitFormat={unitFormat}
        startValue={startValue}
        currentValue={currentValue}
        target={target}
        timeframeDifference={timeframeDifference}
        startDate={startDate}
        endDate={endDate}
        weekStartsOn={weekStartsOn}
        numberFormat={numberFormat}
        isEmpty={isEmpty}
        isLink={isLink}
        isLoading={isLoading}
        showLeftAxis={showLeftAxis}
      />
    </Styled.Container>
  );
};
